import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/client';
import type { Envelope } from '@/shared/api/types';

export type RouteMode = 'walk' | 'car';

export interface RouteCoords {
  x: string;
  y: string;
}

export interface RouteResult {
  mode: string;
  distanceMeters: number;
  durationSeconds: number;
  taxiFare: number | null;
}

async function fetchRoute(
  origin: RouteCoords,
  dest: RouteCoords,
  mode: RouteMode,
): Promise<RouteResult> {
  const params = new URLSearchParams({
    originX: origin.x,
    originY: origin.y,
    destX: dest.x,
    destY: dest.y,
    mode,
  });
  const { data } = await api.get<Envelope<RouteResult>>(
    `/routes?${params.toString()}`,
  );
  return data.data;
}

export function useRoute(
  origin: RouteCoords | null,
  dest: RouteCoords | null,
  mode: RouteMode,
) {
  return useQuery({
    queryKey: ['routes', origin?.x, origin?.y, dest?.x, dest?.y, mode],
    queryFn: () => fetchRoute(origin!, dest!, mode),
    enabled: origin !== null && dest !== null,
    staleTime: 60_000,
  });
}
